module.exports = __webpack_public_path__ + "img/shixiao_poster.fd998de8.jpg";